import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Pill from 'aquilla/core/molecules/Pill';
import React, { useState } from 'react';
import { M } from 'aquilla/icons/topics/M';
import { V } from 'aquilla/icons/topics/V';
import { segment } from '@actions/analytics';
import SimilarClasses from './SimilarClasses';
import { CLASS_CHIP_FILTER_CLICKED } from '../constants';

const PlaylistHeader = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_3B};
`;

const PillWrapper = styled.div`
  cursor: pointer;
  display: flex;
  gap: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_4B};
  svg {
    path {
      display: none;
    }
  }

  > button {
    max-height: ${Spacings.SPACING_8B};
    flex-shrink: 0;
    > span {
      font-weight: ${Fonts.SEMIBOLD};
    }
  }
`;

const Playlist = ({ classUID, author }) => {
  const [type, setType] = useState(0);
  const sendEvent = (filterType) => {
    segment.track(CLASS_CHIP_FILTER_CLICKED, {
      last_primary_source: 'Side Nav Bar',
      type: filterType === 0 ? 'Similar classes' : 'From educator'
    });
  };

  return (
    <>
      <PlaylistHeader variant="h5" color="var(--color-text-secondary)">
        More free classes
      </PlaylistHeader>
      <PillWrapper>
        <Pill
          title="Similar classes"
          isSelected={type === 0}
          icon={<M height={24} width={24} />}
          onClick={() => {
            setType(0);
            sendEvent(0);
          }}
        />
        <Pill
          title={`by ${author.name}`}
          isSelected={type === 1}
          icon={<V height={24} width={24} />}
          onClick={() => {
            setType(1);
            sendEvent(1);
          }}
        />
      </PillWrapper>
      <SimilarClasses classUID={classUID} type={type} />
    </>
  );
};

export default Playlist;
